<template>
  <div>
    <div class="con-vs-loading vs-loading-color-success">
      <div class="vs-loading default" style="transform: scale(0.4);">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>

    &nbsp;
  </div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style scoped>

</style>
